export default __webpack_public_path__ + "static/media/pictogramBeaconBNPL40.673afabf.svg";